import { render, staticRenderFns } from "./OrderNoteTemplate.vue?vue&type=template&id=0d057554&scoped=true"
import script from "./OrderNoteTemplate.vue?vue&type=script&lang=js"
export * from "./OrderNoteTemplate.vue?vue&type=script&lang=js"
import style0 from "./OrderNoteTemplate.vue?vue&type=style&index=0&id=0d057554&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d057554",
  null
  
)

export default component.exports